export default {
  beforeMount(el, binding) {
    if (binding.value === false) return // 如果参数为 false，则禁用拖动

    el._isDragging = false
    el._startX = 0
    el._scrollLeft = 0

    const startDragging = (e) => {
      el._isDragging = true
      el._startX = e.pageX - el.offsetLeft
      el._scrollLeft = el.scrollLeft
      el.style.cursor = 'grabbing'
    }

    const stopDragging = () => {
      el._isDragging = false
      el.style.cursor = 'grab'
    }

    const drag = (e) => {
      if (!el._isDragging) return
      e.preventDefault()
      const x = e.pageX - el.offsetLeft
      const walk = (x - el._startX) * 2 // Scroll-fast
      el.scrollLeft = el._scrollLeft - walk
    }

    el.addEventListener('mousedown', startDragging)
    el.addEventListener('mouseup', stopDragging)
    el.addEventListener('mousemove', drag)
    el.style.cursor = 'grab'

    // Store cleanup functions
    el._cleanupDragScroll = () => {
      el.removeEventListener('mousedown', startDragging)
      el.removeEventListener('mouseup', stopDragging)
      el.removeEventListener('mousemove', drag)
    }
  },
  updated(el, binding) {
    if (binding.oldValue !== binding.value) {
      // Cleanup if the value changes
      if (binding.oldValue !== false) {
        el._cleanupDragScroll()
      }
      if (binding.value === false) {
        el.style.cursor = ''
      }
    }
  },
  unmounted(el) {
    if (el._cleanupDragScroll) {
      el._cleanupDragScroll()
    }
  },
}
